var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-3 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-5 {\n        fill: none;\n        stroke: #000;\n        stroke-width: 3px;\n      }\n\n      .cls-5 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m23.43,46.74c0-4.21,6.43-7.62,14.26-7.62s14.25,3.41,14.25,7.62v2.3c0,.49-.4.89-.89.89h-26.74c-.49,0-.89-.4-.89-.89v-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.69,25.07c2.25,0,4.08,1.83,4.08,4.08s-1.83,4.08-4.08,4.08-4.08-1.83-4.08-4.08,1.83-4.08,4.08-4.08m0-3c-3.91,0-7.08,3.17-7.08,7.08s3.17,7.08,7.08,7.08,7.08-3.17,7.08-7.08-3.17-7.08-7.08-7.08h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m65.8,37.5c0,15.53-12.59,28.11-28.11,28.11s-28.11-12.59-28.11-28.11,12.59-28.11,28.11-28.11c10.78,0,20.14,6.06,24.86,14.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.58 22.9 51.19 20.73 61.87 23.74 64.09 12.87 66.29 13.32 63.59 26.56 50.58 22.9"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 -5.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Change "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 34.48,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.57,
    y: 0
  }, "se"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 49.81,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 52.97,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeUser);
export default __webpack_public_path__ + "static/media/__Change User.fc05496d30b2d2995edef75ac604741a.svg";
export { ForwardRef as ReactComponent };